var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.5,
    y: 0.5,
    width: 19,
    height: 24,
    rx: 1.5,
    fill: "#F2F2F2",
    stroke: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 0.5,
    y: 2.5,
    width: 19,
    height: 24,
    rx: 1.5,
    fill: "white",
    stroke: "#595959"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Speaker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6 11.375V12.625H16V11.375H13.6ZM12.4 15.5063C12.976 15.95 13.726 16.5375 14.32 17C14.56 16.6687 14.8 16.3313 15.04 16C14.446 15.5375 13.696 14.95 13.12 14.5C12.88 14.8375 12.64 15.175 12.4 15.5063ZM15.04 8C14.8 7.66875 14.56 7.33125 14.32 7C13.726 7.4625 12.976 8.05 12.4 8.5C12.64 8.83125 12.88 9.16875 13.12 9.5C13.696 9.05 14.446 8.46875 15.04 8ZM5.2 10.125C4.54 10.125 4 10.6875 4 11.375V12.625C4 13.3125 4.54 13.875 5.2 13.875H5.8V16.375H7V13.875H7.6L10.6 15.75V8.25L7.6 10.125H5.2ZM12.1 12C12.1 11.1688 11.752 10.4187 11.2 9.90625V14.0875C11.752 13.5813 12.1 12.8313 12.1 12Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 6,
    y: 21,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 7,
    y: 23,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrSocial);
export default __webpack_public_path__ + "static/media/icon-qr-social.aff37da8926cccfb9656fc694fd780e9.svg";
export { ForwardRef as ReactComponent };